function resolveLobbyMemberNickname(member, friends) {
  const friendMatch = friends.find(
    (friend) => friend.friendData?.userId === member?.userId
  );

  return (
    friendMatch?.friendData?.nickname ||
    member?.nickname ||
    member?.friendData?.nickname ||
    null
  );
}

export function handleLobbyPlayerAddedMessage({
  event,
  user,
  actions,
  currentLobby,
  friends = [],
}) {
  if (!event?.lobby) {
    return;
  }

  actions.updateLobbyWithNewPlayer(event.lobby);

  const previousMembers = Array.isArray(currentLobby?.members)
    ? currentLobby.members
    : null;

  if (!previousMembers || previousMembers.length === 0) {
    return;
  }

  const previousMemberIds = new Set(
    previousMembers.map((member) => member?.userId).filter(Boolean)
  );
  const addedMembers = (event.lobby.members || []).filter(
    (member) => member?.userId && !previousMemberIds.has(member.userId)
  );

  if (addedMembers.length !== 1) {
    return;
  }

  const addedMember = addedMembers[0];

  if (user && addedMember.userId === user.userId) {
    return;
  }

  const nickname = resolveLobbyMemberNickname(addedMember, friends);

  if (nickname) {
    actions.showPlayerJoinedNotification(nickname);
  }
}

export function handleLobbyPlayerLeftMessage({
  event,
  user,
  actions,
  friends = [],
  clearInviteCodeState = () => {},
}) {
  if (!event) {
    return;
  }

  if (user && event.leftUserId === user.userId) {
    actions.leaveLobby();
    clearInviteCodeState();
    return;
  }

  actions.lobbyPlayerLeft(
    event.lobbyCode,
    event.leftUserId,
    event.hostChanged,
    event.newHostId,
    event.totalPlayers
  );

  const leavingFriend = friends.find(
    (friend) => friend.friendData?.userId === event.leftUserId
  );

  if (leavingFriend) {
    actions.showPlayerLeftNotification(leavingFriend.friendData.nickname);
  }
}
